export const PRESENTATION_SLIDE_KINDS = Object.freeze({
  CARDS: 'cards',
  CHART: 'chart',
  IMAGE: 'image',
  METADATA: 'metadata',
  TABLE: 'table',
  TAKEAWAYS: 'takeaways',
  TEXT: 'text',
  TORNADO: 'tornado',
  TREE: 'tree',
  WATERFALL: 'waterfall',
});

export const PRESENTATION_CHART_TYPES = Object.freeze({
  BAR: 'bar',
  COLUMN: 'column',
  COMBO: 'combo',
  LINE: 'line',
  SCATTER: 'scatter',
});
